import React, { useEffect, useState } from "react";
import CustomModal from "../../../../components/generic/custommodal/CustomModal";
import TrainingItemForm from "./TrainingItemForm";
import SecondaryButton from "../../../../components/generic/buttons/SecondaryButton";
import PrimaryButton from "../../../../components/generic/buttons/PrimaryButton";
import {
  addTrainingItem,
  getTrainingItem,
  updateTrainingItem,
  uploadDocument,
} from "../../../articles/StrapiService";
import { notification, Spin } from "antd";
import { useGetOrgIdentifier } from "../../../generic/hooks/useGetOrgIdentifier";

const TrainingItemFormModal = ({
  showTriningItem,
  setShowTrainingItem,
  trainingItemId,
  setTrainingItemId,
  getModules,
  moduleId,
  setModuleId,
}) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [trainingItem, setTrainingItem] = useState(null);
  const [roles, setRoles] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  const handleCancleClick = () => {
    setTrainingItemId("");
    setModuleId("");
    setShowTrainingItem(false);
    setTrainingItem(null);
    setErrors({});
    setRoles([]);
  };

  const validate = (values) => {
    const errors = {};
    if (!values?.title) {
      errors.title = "Title is required!";
    }
    if (!values?.sequenceId) {
      errors.sequenceId = "Sequence number is required!";
    }
    if (!values?.training_roles) {
      errors.roles = "Role is required!";
    }
    if (!values?.fileName) {
      errors.fileName = "Please upload a document";
    }
    return errors;
  };

  const handleEditTrainingItem = async (id) => {
    const validationErrors = validate(trainingItem);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setLoading(true);
      try {
        let uploadedFileId = trainingItem?.mediaId;

        // Step 1: Upload file to Strapi (media upload)
        if (trainingItem.file) {
          const uploadRes = await uploadDocument(trainingItem?.file);
          uploadedFileId = uploadRes;
        }

        const response = await updateTrainingItem(id, {
          ...trainingItem,
          video: uploadedFileId,
        });

        if (response.status === 200) {
          notification.success({
            message: "Training item updated successfully!",
            placement: "bottomRight",
          });
        } else {
          notification.error({
            message: "Something went wrong. Please try again.",
            placement: "bottomRight",
          });
        }
      } catch (err) {
        notification.error({
          message: "Something went wrong. Please try again.",
          placement: "bottomRight",
        });
      } finally {
        setTrainingItem(null);
        setRoles([]);
        setLoading(false);
        getModules();
        setModuleId("");
        setTrainingItemId("");
        setLoading(false);
        setShowTrainingItem(false);
      }
    }
  };

  const handleAddClick = async (e) => {
    e.preventDefault();

    const validationErrors = validate(trainingItem);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setLoading(true);
      try {
        let uploadedFileId = null;

        // Step 1: Upload file to Strapi (media upload)
        if (trainingItem.file) {
          const uploadRes = await uploadDocument(trainingItem?.file);
          uploadedFileId = uploadRes;
        }

        const res = await addTrainingItem({
          ...trainingItem,
          organizationIdentifier,
          training_module: moduleId,
          video: uploadedFileId,
        });

        if (res.status === 200) {
          notification.success({
            message: "Training Item added successfully!",
            placement: "bottomRight",
          });
        } else {
          notification.error({
            message: "Something went wrong. Please try again.",
            placement: "bottomRight",
          });
        }
      } catch (err) {
        notification.error({
          message: "Something went wrong. Please try again.",
          placement: "bottomRight",
        });
      } finally {
        setTrainingItem(null);
        setRoles([]);
        setLoading(false);
        setModuleId("");
        setTrainingItemId("");
        getModules();
        setLoading(false);
        setShowTrainingItem(false);
      }
    }
  };

  const handleClick = async (e) => {
    if (trainingItemId) {
      handleEditTrainingItem(trainingItemId);
    } else {
      handleAddClick(e);
    }
  };

  useEffect(() => {
    const getTrainingItemData = async () => {
      setDataLoading(true);
      const { data } = await getTrainingItem(trainingItemId);
      if (data) {
        const moduleData = {
          sequenceId: data.attributes?.sequenceId,
          description: data.attributes?.description,
          title: data.attributes?.title,
          fileName: data.attributes?.video?.data?.attributes?.name,
          mediaId: data.attributes?.video?.data?.id,
          organizationIdentifier: data.attributes?.organizationIdentifier,
          training_roles: data.attributes?.training_roles?.data?.map(
            (item) => ({
              id: Number(item?.id),
            })
          ),
        };
        setModuleId(data.attributes?.training_module?.data?.id);
        setRoles(
          data.attributes?.training_roles?.data?.map((item) => ({
            label: item?.attributes?.role,
            value: item?.id,
          }))
        );
        setTrainingItem(moduleData);
      }
      setDataLoading(false);
    };
    if (trainingItemId) {
      getTrainingItemData();
    }
  }, [setModuleId, trainingItemId]);

  const footerButtons = (
    <>
      <SecondaryButton buttonText="Cancel" handleOnClick={handleCancleClick} />
      <PrimaryButton
        buttonText={trainingItemId ? "Edit" : "Add"}
        handleOnClick={handleClick}
        loading={loading}
      />
    </>
  );
  return (
    <>
      <CustomModal
        isModalOpen={showTriningItem}
        footer={footerButtons}
        closable={false}
        closeModal={setShowTrainingItem}
        title={`${trainingItemId ? "Edit" : "Add"} Training Item`}
      >
        {dataLoading ? (
          <Spin className="spinnerCenter" />
        ) : (
          <TrainingItemForm
            trainingItem={trainingItem}
            setTrainingItem={setTrainingItem}
            errors={errors}
            setRoles={setRoles}
            roles={roles}
          />
        )}
      </CustomModal>
    </>
  );
};

export default TrainingItemFormModal;
